/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import Vuex from 'vuex';

import store from './store.js'

import VeeValidate from 'vee-validate'
import DateRangePicker from 'vue2-daterange-picker'
import Vue from 'vue';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import VueHtmlToPaper from 'vue-html-to-paper';
// import VueEcho from 'vue-echo-laravel';
import Clipboard from 'v-clipboard';
import * as Sentry from "@sentry/vue";
/*
* Use the Vue Material  https://vuematerial.io/
*For system perfomance import necessary componenents in my case
* I am going to import the full package
*
 */

// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
// import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import VueMyToasts from 'vue-my-toasts'
import 'vue-my-toasts/dist/vue-my-toasts.css'
import BootstrapVueToast from 'vue-my-toasts/src/components/toasts/BootstrapComponent'
import VueSound from 'vue-sound/src/components/VueSound'
import cacheRefreshService from './services/cacheRefreshService';

cacheRefreshService.start(30 * 60 * 1000); // Refresh every 10 minutes

const vuePrintOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/css/print.css',
  ],
  timeout: 1000, // default timeout before the print window appears
  autoClose: true, // if false, the window will not close after printing
  windowTitle: window.document.title, // override the window title
}

Vue.use(VueHtmlToPaper, vuePrintOptions);

// or, using the defaults with no stylesheet
Vue.use(VueHtmlToPaper);
Vue.use(VueHtmlToPaper,vuePrintOptions);
Vue.use(VueMyToasts, {
    component: BootstrapVueToast,
    options: {
        width: '400px',
        position: 'top-right',
        padding: '1rem',
    },
});


const datepickerOptions = {};
// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
// var VueDropdown = require('vue-dynamic-dropdown/dropdown');
Vue.component('previewupload', require('./components/ProfilePreviewEditSingle.vue').default);
Vue.component('Inventory', require('./components/inventory/Inventory.vue').default);
Vue.component('Purchases', require('./components/inventory/Purchases.vue').default);
Vue.component('GroupedInventory', require('./components/inventory/GroupedInventory.vue').default);
Vue.component('InventoryActivity', require('./components/inventory/InventoryActivity.vue').default);
Vue.component('Expenses', require('./components/expenses').default);
Vue.component('Employees', require('./components/employees/employee').default);
Vue.component('Customers', require('./components/customers/index').default);
Vue.component('CustomerProfile', require('./components/customers/CustomerProfile').default);
Vue.component('CustomerProductInsight', require('./components/customers/CustomersProductInsights').default);
Vue.component('Wastes', require('./components/wastes').default);
Vue.component('Suppliers', require('./components/suppliers/index').default);
Vue.component('SupplierStatement', require('./components/suppliers/supplierStatement').default);
Vue.component('fileuploader', require('./components/fileUploader').default);
Vue.component('Sell', require('./components/Salespage').default);
Vue.component('Search', require('./components/search').default);
Vue.component('Payment', require('./components/paymentpage').default);
Vue.component('checkoutdone', require('./components/checkoutdone').default);
Vue.component('checkout', require('./components/checkout').default);
Vue.component('quantity', require('./components/modal/quantity').default);
Vue.component('ModalCustomers', require('./components/modal/customers').default);
Vue.component('Daterange',require('./components/DateRange').default);
Vue.component('Cashdrawer',require('./components/CashDrawer').default);
Vue.component('Invoice',require('./components/invoice').default);
Vue.component('Orders',require('./components/AllOrders').default);
Vue.component('SalesAnalytics',require('./components/analytics/sales').default);
Vue.component('BottomMenu',require('./components/partials/BottomMenu').default);
Vue.component('Services',require('./components/services').default);
Vue.component('FullCal',require('./components/partials/FullCalendar').default);
Vue.component('UserProfile',require('./components/profile').default);
Vue.component('GeneralSettings',require('./components/settings/generalsettings').default);
Vue.component('PaymentsSettings',require('./components/settings/paymentsettings').default);
Vue.component('InventorySettings',require('./components/settings/inventorysettings').default);
Vue.component('ReportsSettings',require('./components/settings/reportsettings').default);
Vue.component('ReceiptSettings',require('./components/settings/receiptsettings').default);
Vue.component('IntegrationSettings',require('./components/settings/integrations').default);
Vue.component('BulkRestock',require('./components/inventory/BulkRestock').default);
Vue.component('IndexReservation',require('./components/Reservations/index').default);
Vue.component('MakeReservation',require('./components/Reservations/MakeReservation').default);
Vue.component('IndexPayroll',require('./components/payroll/IndexPayroll').default);

// Vue.component('Notifications',require('./components/Notifications').default);
Vue.component('LeaveApplications',require('./components/leaveapplications').default);
Vue.component('SalaryAdvance',require('./components/salaryadvances').default);
Vue.component('EmployeeAttendance',require('./components/employees/EmployeeAttendance').default);
Vue.component('Appointments',require('./components/appointments').default);
Vue.component('HomejsData',require('./components/HomejsData').default);
Vue.component('MakeSaleHome',require('./components/MakeSale').default);
Vue.component('OnboardingProcess',require('./components/Onboarding').default);
Vue.component('RegisterBusiness',require('./components/registerbusiness').default);
Vue.component('DashboardSaleschart',require('./components/analytics/charts/dashboardsales').default);
Vue.component('AddProduct',require('./components/inventory/AddProduct').default);
Vue.component('BillingPage',require('./components/BillingPage').default);
Vue.component('BnplPage',require('./components/BNPL').default);
Vue.component('LoaderSpin', require('./components/partials/loader.vue').default);
Vue.component('CustomerInvoice', require('./components/partials/loader.vue').default);
Vue.component('CustomerOrderView', require('./components/customers/CustomerOrderView').default);
Vue.component('StockTake', require('./components/inventory/StockTake.vue').default);
Vue.component('InventoryVarianceReport', require('./components/inventory/InventoryVarianceReport.vue').default);
Vue.component('PaymentTransactions', require('./components/Transactions/PaymentTransactions.vue').default);
Vue.component('SettingsMenu', require('./components/settings/menu.vue').default);
Vue.component('OtpVerification', require('./components/Auth/OtpVerification.vue').default);
Vue.component('KitchenDisplaySys', require('./components/Sales/KitchenDisplay.vue').default);
Vue.component('NightAudit', require('./components/Reservations/NightAudit.vue').default);




// admin components
Vue.component('AdminDashboard', require('./components/Admin/Dashboard').default);
Vue.component('AffiliatesDashboard', require('./components/affiliates/index').default);

// Vue.component('vue-dropdown',VueDropdown);



// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
/*
* TODO: rem to ENABLE VEEVALIDATE LATER
 */
// Vue.use(VeeValidate);
Vue.use(VueSound);

Vue.use(Clipboard);

Vue.use(DateRangePicker);
/*
*Use the Vue Material  https://vuematerial.io/
 */
// Vue.use(VueMaterial);


// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.use(VueTelInput,{
    defaultCountry:'KE',
    autoDefaultCountry:true,
    dropdownOptions:{
      showSearchBox:true,
    },
    inputOptions:{
      placeholder:"E.g 0712345678",
      required:true
    },
    mode:'international'
});

// Vue.use(AirbnbStyleDatepicker, datepickerOptions);

// Vuex
Vue.use(Vuex);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// Vue.use(VueEcho, {
//   broadcaster: 'pusher',
//   host: window.location.hostname + ':6001',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: false,
//     disableStats: true,
// });

Vue.prototype.convertCurrencyToShillings = function(amount) {
  if (amount === null || amount === undefined) {
    return '';
  }

  let currencyCode = 'KES'; // Default currency
  const userDetailsStr = localStorage.getItem('userDetails');

  // Check if userDetailsStr is not null and parse only if it exists
  if (userDetailsStr) {
    try {
      const userDetails = JSON.parse(userDetailsStr);

      // Check if the company settings and currency exist and are not 'null'
      if (userDetails.company &&
          userDetails.company.companysettings &&
          userDetails.company.companysettings.currency !== 'null') {
        currencyCode = userDetails.company.companysettings.currency;
      }
    } catch (error) {
      console.error("Error parsing userDetails:", error);
    }
  }

  return amount.toLocaleString('en', {
    style: 'currency',
    currency: currencyCode
  });
};

Vue.prototype.convertCurrencyToLocal = function(amount) {
  if (amount === null || amount === undefined) {
    return '';
  }
  let currencyCode =''
  const userDetails = JSON.parse(localStorage.getItem('userDetails'))

  if(userDetails && userDetails.company.companysettings.currency !=='null')
  {
    currencyCode = userDetails.company.companysettings.currency
  }
  else{
    currencyCode = 'KES';
  }

  return amount.toLocaleString('en', {
    style: 'currency',
    currency: currencyCode
  });
};
Vue.prototype.hasPermission = function(permission) {
   return this.userDetails.permissions.some(permission => permission.name === permissionName);
};
moment.tz.setDefault('Africa/Nairobi');
Vue.prototype.$moment = moment;

// Introduce sentry
      Sentry.init({
        Vue,
        dsn: "https://a7722dbddd220a85d0cdc2dd3d7c2310@o4508320947568640.ingest.us.sentry.io/4508371254181888",
        integrations: [
          Sentry.replayIntegration(),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
      });
new Vue({
  el: "#app",

  mounted() {

      // Listen for the 'NewBlogPost' event in the 'team.1' private channel
    //   this.$echo.private('billing-notifications.' + 1)
    //   .listen('.billing-notif-sent', (e) => {
    //       // Handle received message here
    //       console.log(e.messageDetails.message);
    //   });

      this.enableInterceptor();
  },
  store: new Vuex.Store(store),
  data: {
      isLoading: false,
      axiosInterceptor: null,
  },

  methods: {
      enableInterceptor() {
       const vm = this
       vm.axiosInterceptor = window.axios.interceptors.request.use((config) => {
        vm.isLoading = true
              return config
          }, (error) => {

            vm.isLoading = false
              return Promise.reject(error)
          })

          window.axios.interceptors.response.use((response) => {

            vm.isLoading = false
              return response
          }, function(error) {
            vm.isLoading = false

              return Promise.reject(error)
          })
      },



      disableInterceptor() {
          window.axios.interceptors.request.eject(this.axiosInterceptor)
      },


  },
})

